import React, { useMemo, useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import { UserContext } from '../../Contexts/UserContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

const GeneralIconButton = (props) => {
	const { getAccessControlSet } = useContext(UserContext);
	const system = props.system || SYSTEMS.FRAMERATE;

	/**
	 * This variable contains a set of strings that signifies if this button is either visible/disabled/hidden
	 * @type {Set<string>}
	 */
	const generalIconButtonControlledAccessSet = useMemo(() => {
		return getAccessControlSet(system, TYPES.BUTTON_NAMES, props.name);
	}, [getAccessControlSet, props.name, system]);

	return (
		<>
			{!generalIconButtonControlledAccessSet.has(UI_ACCESS.HIDE) && (
				<IconButton
					{...props}
					disabled={props.disabled || generalIconButtonControlledAccessSet.has(UI_ACCESS.DISABLE)}
				>
					{props.children}
				</IconButton>
			)}
		</>
	);
};
export default GeneralIconButton;
